import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import './PublicPages.css';

const Home = () => {
  const { cases, hearings } = useApp();
  const today = new Date().toISOString().split('T')[0];
  const todayHearings = hearings.filter(h => h.hearingDate === today && h.status === 'Scheduled');

  const features = [
    {
      icon: '📁',
      title: 'Case Management',
      description: 'Comprehensive case registration and tracking system with automated case number generation.',
    },
    {
      icon: '📅',
      title: 'Hearing Scheduling',
      description: 'Efficient hearing scheduling and management with court and judge allocation.',
    },
    {
      icon: '📄',
      title: 'Document Management',
      description: 'Secure document storage and management with role-based access control.',
    },
    {
      icon: '⚖️',
      title: 'Judgment & Orders',
      description: 'Digital judgment entry and order management system for case closure.',
    },
    {
      icon: '📋',
      title: 'Cause List',
      description: 'Daily cause list generation with court-wise and judge-wise views.',
    },
    {
      icon: '🔍',
      title: 'Case Status Tracking',
      description: 'Public case status search by case number, party name, or advocate name.',
    },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Welcome to e-Court Management System</h1>
          <p className="hero-subtitle">
            Streamlining court operations and bringing justice to the digital age
          </p>
          <div className="hero-buttons">
            <Link to="/case-status" className="btn-primary-large">
              Check Case Status
            </Link>
            <Link to="/courts" className="btn-secondary-large">
              View Courts
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{cases.length}</div>
              <div className="stat-label">Total Cases</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{todayHearings.length}</div>
              <div className="stat-label">Today's Hearings</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{cases.filter(c => c.status === 'Disposed').length}</div>
              <div className="stat-label">Disposed Cases</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">System Availability</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive court management solutions for modern judiciary
          </p>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Need Help with Your Case?</h2>
          <p>Track your case status, view cause lists, and access court information</p>
          <div className="cta-buttons">
            <Link to="/case-status" className="btn-primary-large">
              Track Case Status
            </Link>
            <Link to="/contact" className="btn-secondary-large">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

